/** @license ISC License (c) copyright 2018 original and current authors */
/** @author Robert Pearce (rpearce) */

module.exports =
  require('../core/isSymbol')
